<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
  >
    <path
      d="M0.5 4.5C0.5 2.567 2.067 1 4 1H12C13.933 1 15.5 2.567 15.5 4.5V12.5C15.5 14.433 13.933 16 12 16H4C2.067 16 0.5 14.433 0.5 12.5V4.5Z"
      fill="#A6D3F4"
      stroke="#00A8E8"
    />
  </svg>
</template>
